import { render, staticRenderFns } from "./SlideContentWrapper.vue?vue&type=template&id=695100fa&scoped=true&"
import script from "./SlideContentWrapper.vue?vue&type=script&lang=js&"
export * from "./SlideContentWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SlideContentWrapper.vue?vue&type=style&index=0&id=695100fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695100fa",
  null
  
)

export default component.exports